module.exports = __webpack_public_path__ + "static/media/logo_saigonbank.9e26d230.svg";